import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import { contentHeaders } from "@/lib/seo/contentCache";
import Guides from "@/pages/Guides";

export const Route = createFileRoute("/guides/")({
  head: () => seoHead("/guides/"),
  // The listing must pick up newly published guides without a deploy.
  headers: () => contentHeaders(true),
  component: Guides,
});
